import { Component, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ContractDto } from 'src/app/models/contractDto';
import { CostCenterDto } from 'src/app/models/CostCenterDto';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { NotificationType } from 'src/app/models/notification.message';
import { ContractVm } from 'src/app/models/requests/ConractVm';
import { VendorDto } from 'src/app/models/VendorDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { CostCentersService } from 'src/app/services/costcenters.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { LocationsService } from 'src/app/services/locations.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { VendorsService } from 'src/app/services/vendors.service';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { Profile } from 'src/app/models/profile';
import { UserService } from 'src/app/services/user.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-new-contract',
  templateUrl: './new-contract.component.html',
  styleUrls: ['./new-contract.component.css']
})
export class NewContractComponent implements OnInit {

  @ViewChild('ngNewContractForm') theForm: any;

  Locations: LocationDto[] | undefined;
  CostCenters: CostCenterDto[] | undefined;
  Departments: DepartmentDto[] = [];
  selectedLocationId: number = 0;
  selectedDepartmentId: number = 0;
  selectedCostCenterId: number = 0;
  functionId: number = 0;
  selectedPlantManagerId: string = ''
  description: string = ''
  funcdirectorCount : number = 0;
  hrbpCount : number = 0;
  hrCount : number = 0;
  procurementDirector : number = 0;
  ohrdToApprove: string = '';
  procurementDirectorToApprove: string = '';
  justification: string = '';
  noOfStaff: number = 0;
  qualification: string = '';
  modeOfHeadCount: string = '';
  renewalOrNew: string = '';
  PlantManagers:Profile[]=[];
  totalCost: number = 0;
  contractDuration: number = 0;
  shortName: string = '';
  expectedStartDate: Date = new Date;
  isPOMandatory: boolean = false;
  selectedManagerId:string="";
  isShowPlantManager:boolean=false;
  Managers:Profile[]=[];
  selectedhrbpId:string="";
  HRBPS:Profile[]=[];

  selectedfunctionalDirectorId:string="";
  FunctionalDirectors:Profile[]=[];
  modeOfHeadCountDropdown = [
  { option: 'Manpower' },
  { option: 'Service Provider' }
];
  requestTypeDropdown = [
  { option: 'New' },
  { option: 'Renewal' }
];


  isSubmitted = false;

  constructor(private vendorService: VendorsService, private locationService: LocationsService,
    private departmentService: DepartmentsService, private contractService: ContractsService, private notification: NotificationService,
    private costCenterService: CostCentersService, private nznotification: NzNotificationService, private tokenService: TokenService,  private userService: UserService) { }

  ngOnInit(): void {

    this.LoadDropDowns();
  }

  async LoadDropDowns() {

    if (this.isShowPlantManager == false){
      this.hrbpCount = 2
      this.funcdirectorCount = 3
      this.procurementDirector = 4
      this.hrCount = 5
   
    }
    let resLocations = await this.locationService.getLocations().toPromise();
    this.Locations = <LocationDto[]>resLocations.responseData;

    let resCostCenterss = await this.costCenterService.getCostCenters().toPromise();
    this.CostCenters = <CostCenterDto[]>resCostCenterss.responseData;

    var profile = this.tokenService.getInfo();
    this.selectedDepartmentId = profile.profile.departmentId;


    let plantManager = await this.userService.getManagersUsers().toPromise();
    this.PlantManagers = <Profile[]>plantManager.responseData;

    let usersPro = await this.userService.getManagersUsers().toPromise();
    this.Managers = <Profile[]>usersPro.responseData;

    let userhrpbps = await this.userService.getHRBPS().toPromise();
    this.HRBPS = <Profile[]>userhrpbps.responseData;
    
    let procurementDirector = await this.userService.getProcurementDirector().toPromise();
    let procurementDirectorRes = <Profile[]>procurementDirector.responseData;
    this.procurementDirectorToApprove = procurementDirectorRes[0].email;

    let ohrDirector = await this.userService.getOHRDirector().toPromise();
    let ohrDirectorRes = <Profile[]>ohrDirector.responseData;
    this.ohrdToApprove = ohrDirectorRes[0].email;
     
    let resDeparts = await this.departmentService.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;

    let directors = await this.userService.getFunctionalDirectors().toPromise();
    this.FunctionalDirectors = <Profile[]>directors.responseData;
  }

   onChangeMode(event:string)
  {
   this.modeOfHeadCount = event;
  }
  onChangeModetype(event:string)
  {
   this.renewalOrNew = event;
  }
  
  onChangeFunction(event:string)
  {
   
   const contractfunction:string=(event);
   let item = this.Departments.find(i => i.id.toString() === contractfunction);

if(item?.id=== 8)
{
 this.isShowPlantManager=true;
      this.hrbpCount = 3
      this.funcdirectorCount = 4
      this.procurementDirector = 5
      this.hrCount = 6
  
}
else{
this.isShowPlantManager=false;
this.hrbpCount = 2
this.funcdirectorCount = 3
this.procurementDirector = 4
this.hrCount = 5


}
}

  onSubmit(): void {
    

if(this.selectedManagerId.length==0)
{
  this.notification.sendMessage({
    message: `Please select Unit head to approve request`,
    type: NotificationType.success
  });


}
if(this.selectedhrbpId.length==0)
{
  this.notification.sendMessage({
    message: `Please select HRBP to approve request`,
    type: NotificationType.success
  });

}
if(this.selectedfunctionalDirectorId.length==0)
{
  this.notification.sendMessage({
    message: `Please select Functional Director to approve request`,
    type: NotificationType.success
  });

}   

let ContractVm: ContractVm = {
      departmentId: this.selectedDepartmentId,
      locationId: this.selectedLocationId,
      costCenterId: this.selectedCostCenterId,
      functionId: this.functionId,
      contractDuration: this.contractDuration.toString(),
      budgetCost: this.totalCost,
      expectedStartDate: this.expectedStartDate,
      description: this.description,
      justification: this.justification,
      noOfStaff: this.noOfStaff,
      qualification: this.qualification,
      unitHeadToApprove:this.selectedManagerId,
      PlantManagerToApprove:this.selectedPlantManagerId,
      hrbpToApprove:this.selectedhrbpId,
      functionalDirectorToApprove:this.selectedfunctionalDirectorId,
      procurementDirectorToApprove: this.procurementDirectorToApprove,
      ohrdToApprove: this.ohrdToApprove,
      modeOfHeadCount: this.modeOfHeadCount,
      renewalOrNew: this.renewalOrNew
      
    };

    this.contractService.saveContract(ContractVm).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Request created successfully with reference : ${data.responseData.reference}`,
            type: NotificationType.success
          });

          this.theForm.resetForm();
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });


  }
  createNotification(type: string, message: string): void {
    this.nznotification.create(
      type,
      'Notification Title',
      message
    );
  }
}
